import React, { useState } from 'react'
import { Select, Button } from 'antd';


const { Option } = Select;
const typeList = ['Baler', 'Seed Drill', 'Happy Seeder', 'Blower', 'Rake', 'Roader'];
const brandList = ['Mahindra', 'John Deer', 'Eicher', 'Sonalika', 'Escort'];
const hpList = ['Upto 20', '21-30', '31-40', '41-50', '51-60', '61-70', 'above 71'];


function ImplementsSearch() {
    const [brand, setBrand] = useState("")
    const [hp, setHp] = useState("")
    const [type, setType] = useState("")

    const onSearch = () => {

    }

  return (
    <div>
        <div className="mt-8">
            <div className="mt-5">
                <Select
                    size="large"
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Select Type"
                    // value={type}
                    // defaultValue={brandList[0]}
                    //   onChange={this.handleProvinceChange}
                >
                {brandList.map(b => (
                    <Option key={b}>{b}</Option>
                ))}
                </Select>
            </div>
            <div className="mt-3">
                <Select
                    size="large"
                    showSearch
                    style={{ width: '100%' }}
                    placeholder="Select Brand"
                    // value={brand}
                    // defaultValue={brandList[0]}
                    //   onChange={this.handleProvinceChange}
                >
                {brandList.map(b => (
                    <Option key={b}>{b}</Option>
                ))}
                </Select>
            </div>
            <div className="mt-3">
                <Select
                    size="large"
                    showSearch
                    placeholder="Select HP"
                    style={{ width: '100%' }}
                    // value={hp}
                    // onChange={this.onSecondCityChange}
                >
                {hpList.map(h => (
                    <Option key={h}>{h}</Option>
                ))}
                </Select>
            </div>

            <div className="mt-8">
                <div className="">
                    <Button 
                        type="primary" 
                        size="large"
                        className="w-full" 
                        onClick={onSearch}
                    >
                        Search
                    </Button>
                </div>
                <div className="pt-2 inline">
                    <Button type="link" className="w-full" size="large">Find all implements</Button>
                </div>
            </div>
        </div>
    </div>
  );
}

export default ImplementsSearch;
